import { getTextSize, isValidDate, LABEL_DATE, LABEL_MONTH } from '../../../utils';

export const convertRadiusCheckListToSvg = (data) => {
  const lines = data.split(/\r?\n/);
  const height = lines.length * 20;
  const checkedRadius =
    '<div style="display:inline-block;width:12px;height:12px;margin-right:2px;' +
    'vertical-align:middle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#000000" ' +
    'd="M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 Z M12,20 ' +
    'C16.42,20 20,16.42 20,12 C20,7.58 16.42,4 12,4 C7.58,4 4,7.58 4,12 C4,16.42 7.58,20 12,20 Z M12,17 ' +
    'C9.23857625,17 7,14.7614237 7,12 C7,9.23857625 9.23857625,7' +
    ' 12,7 C14.7614237,7 17,9.23857625 17,12 C17,14.7614237 14.7614237,17 12,17 Z"/></svg></div>';
  const uncheckedRadius =
    '<div style="display:inline-block;width:12px;height:12px;margin-right:2px;' +
    'vertical-align:middle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#000000" ' +
    'd="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"/></svg></div>';
  const font = "font-family:'Helvetica',sans-serif";
  let res = '<div xmlns="http://www.w3.org/1999/xhtml">';
  lines.forEach((line) => {
    const symbol = line[0] === '*' ? checkedRadius : uncheckedRadius;
    const value = line[0] === '*' ? line.substr(1) : line;
    res +=
      '<div style="width:100%;height:100%;font-size:14px;' +
      `line-height:18px">${symbol}<span style="${font};` +
      `vertical-align:middle">${value}</span></div>`;
  });
  res += '</div>';
  res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="200px" height="${height}px">` +
    `<foreignObject width="100%" height="100%">${res}</foreignObject></svg>`;
  return { svg: res, width: 200, height };
};

export const convertBoxCheckListToSvg = (data) => {
  const lines = data.split(/\r?\n/);
  const height = lines.length * 20;
  const checkedBox =
    '<div style="display:inline-block;width:12px;height:12px;margin-right:2px;' +
    'vertical-align:middle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path ' +
    'fill="#000000" d="M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 ' +
    '21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M10.71,16.29 C10.32,16.68 9.69,16.68 9.3,16.29 ' +
    'L5.71,12.7 C5.32,12.31 5.32,11.68 5.71,11.29 C6.1,10.9 6.73,10.9 7.12,11.29 L10,14.17 ' +
    'L16.88,7.29 C17.27,6.9 17.9,6.9 18.29,7.29 C18.68,7.68 18.68,8.31 18.29,8.7 L10.71,16.29 Z"/>' +
    '</svg></div>';
  const uncheckedBox =
    '<div style="display:inline-block;width:12px;height:12px;margin-right:2px;' +
    'vertical-align:middle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path ' +
    'fill="#000000" d="M19,5 L19,19 L5,19 L5,5 L19,5 Z M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 ' +
    '3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z"/></svg></div>';
  const font = "font-family:'Helvetica',sans-serif";
  let res = '<div xmlns="http://www.w3.org/1999/xhtml">';
  lines.forEach((line) => {
    const symbol = line[0] === '*' ? checkedBox : uncheckedBox;
    const value = line[0] === '*' ? line.substr(1) : line;
    res +=
      '<div style="width:100%;height:100%;font-size:14px;' +
      `line-height:18px">${symbol}<span style="${font};` +
      `vertical-align:middle">${value}</span></div>`;
  });
  res += '</div>';
  res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="200px" height="${height}px">` +
    `<foreignObject width="100%" height="100%">${res}</foreignObject></svg>`;
  return { svg: res, width: 200, height };
};

export const convertBulletListToSvg = (data) => {
  const lines = data.split(/\r?\n/);
  const height = lines.length * 23;
  const countLevel = (str) => {
    let i = 0;
    while (str[i] === '#') i += 1;
    return i;
  };
  const font = "font-family:'Helvetica',sans-serif";
  const dot =
    '<div style="display:inline-block;width:6px;height:6px;margin-right:5px">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#CCCCCC"/>' +
    '</svg></div>';
  let res =
    '<foreignObject width="100%" height="100%">' +
    '<div xmlns="http://www.w3.org/1999/xhtml" style="width:100%;' +
    `height:100%;${font};font-size:15px;line-height:20px">`;
  lines.forEach((line) => {
    const curr = countLevel(line);
    res += `<div style="margin-left:${curr * 25}px">${dot}<span style="vertical-align:middle">${line.substr(
      curr,
    )}</span></div>`;
  });
  res += '</div></foreignObject>';
  res = `<svg xmlns="http://www.w3.org/2000/svg" width="250px" height="${height}px">${res}</svg>`;
  return { svg: res, width: 250, height };
};

export const convertTreeListToSvg = (data) => {
  const lines = data.split(/\r?\n/);
  const height = lines.length * 23;
  const countLevel = (str) => {
    let i = 0;
    while (str[i] === '#') i += 1;
    return i;
  };
  const font = "font-family:'Helvetica',sans-serif";
  const downArrow =
    '<div style="display:inline-block;width:15px;height:15px;margin-right:2px;' +
    'vertical-align:middle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' +
    '<path fill="#000000" d="M17,9.17a1,1,0,0,0-1.41,0L12,12.71,8.46,9.17a1,1,0,0,0-1.41,0,' +
    '1,1,0,0,0,0,1.42l4.24,4.24a1,1,0,0,0,1.42,0L17,10.59A1,1,0,0,0,17,9.17Z"/></svg></div>';
  let res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="250px" height="${height}px">` +
    '<foreignObject width="100%" height="100%">' +
    '<div xmlns="http://www.w3.org/1999/xhtml" style="width:100%;' +
    `height:100%;${font};font-size:15px;line-height:20px">`;
  lines.forEach((line, idx) => {
    const curr = countLevel(line);
    const symbol = idx < lines.length - 1 && countLevel(line) < countLevel(lines[idx + 1]) ? downArrow : '';
    res += `<div style="margin-left:${curr * 25}px">${symbol}<span style="vertical-align:middle">${line.substr(
      curr,
    )}</span></div>`;
  });
  res += '</div></foreignObject></svg>';
  return { svg: res, width: 250, height };
};

export const convertTableToSvg = (data) => {
  const lines = data.split(/\r?\n/).filter((i) => i.trim() !== '');
  let width = 0;
  const height = 40 * lines.length;
  const font = "font-family:'Helvetica',sans-serif";
  let res = `<table style="width:100%;${font};height:100%;border-collapse:collapse" border="1">`;

  res += '<tr>';
  const headers = lines[0].split(';');
  const numOfCol = headers.length;
  headers.forEach((header) => {
    const info = header.split('/');
    width += Number(info[1]);
    res += `<th style='width:${info[1]}px;background-color:#9E9E9E;color:white;font-weight:700'>${info[0]}</th>`;
  });
  res += '</tr>';

  let rowIdx = 1;
  lines.slice(1).forEach((line) => {
    const rows = line.split(';');
    if (rows.length < numOfCol) {
      const n = rows.length;
      for (let i = 0; i < numOfCol - n; i += 1) rows.push('');
    }
    res += `<tr style='background-color:${rowIdx === 1 ? '#E6E6E6' : '#FFFFFF'}'>`;
    rows.forEach((r) => {
      res += `<td style='padding-left:5px;padding-right:5px'>${r}</td>`;
    });
    res += '</tr>';
    if (rowIdx === 1) rowIdx = 0;
    else rowIdx = 1;
  });

  res += '</table>';
  res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${width}px"` +
    ` height="${height}px">` +
    '<foreignObject width="100%" height="100%">' +
    '<div xmlns="http://www.w3.org/1999/xhtml" style="width:100%;' +
    `height:100%;font-size:14px">${res}</div>` +
    '</foreignObject>' +
    '</svg>';

  return { svg: res, width, height };
};

export const convertLinkBarToSvg = (data) => {
  const links = data.split(',');
  const width = (data.length - links.length) * 7 + links.length * 20;
  const font = "font-family:'Helvetica',sans-serif";
  let res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${width}px" height="16px">` +
    '<foreignObject width="100%" height="100%">' +
    `<div xmlns="http://www.w3.org/1999/xhtml" style="width:100%;height:100%;${font};font-size:14px">`;
  links.forEach((link, idx) => {
    const color = link[0] === '*' ? 'color:#CCCCCC' : '';
    const seperateSymbol = idx < links.length - 1 ? '<span>|</span>' : '';
    res += `<span style="padding:0 10px;${color}">${link[0] === '*' ? link.substr(1) : link}</span>${seperateSymbol}`;
  });
  res += '</div></foreignObject></svg>';
  return { svg: res, width, height: 16 };
};

export const convertStepNavToSvg = (data) => {
  const steps = data.split(',');
  const width = (steps.length - 1) * 100;
  const font = "font-family:'Helvetica',sans-serif";
  let res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${width}px" height="40px">` +
    '<foreignObject width="100%" height="100%">' +
    '<div xmlns="http://www.w3.org/1999/xhtml">' +
    `<div style="width:${width}px">` +
    `<div style="margin:5px;height:max-content;width:calc(100%-30px);position:relative;${font}">`;
  res +=
    '<div style="position:absolute;width:100%;height:2px;top:calc(50% - 1px);' +
    'background-color:#CCCCCC;z-index:-10"></div>';
  res +=
    '<div style="display:flex;justify-content:space-between;align-items:flex-end;' +
    'width:100%;margin:0;text-align:center">';
  steps.forEach((step) => {
    const color = step[0] === '*' ? 'background-color:#CCCCCC' : 'background-color:#FFFFFF';
    const value = step[0] === '*' ? step.substr(1) : step;
    res +=
      '<div style="border:1px solid #000;height:30px;width:30px;border-radius:100%;color:black;' +
      `display:inline-block;${color};line-height:30px;">${value}</div>`;
  });
  res += '</div></div></div></div></foreignObject></svg>';
  return { svg: res, width, height: 40 };
};

export const convertBreadcrumbToSvg = (data) => {
  const links = data.split(',');
  const caret =
    '<div style="display:inline-block;width:16px;height:16px;vertical-align:middle">' +
    '<svg xmlns="http://www.w3.org/2000/svg" ' +
    'viewBox="0 0 24 24"><path fill="#CCCCCC" ' +
    'd="M19.5,11.13,5.5,3.05a1,1,0,0,0-1,0,1,1,0,0,0-.5.87V20.08a1,1,0,0,0,.5.87,1,1,0,0,0,1,' +
    '0l14-8.08a1,1,0,0,0,0-1.74ZM6,18.35V5.65L17,12Z"/></svg></div>';
  const width = data.length * 10 + links.length * 20 + 10;
  const font = "font-family:'Helvetica',sans-serif";
  let res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${width}px" height="16px">` +
    '<foreignObject width="100%" height="100%">' +
    `<div xmlns="http://www.w3.org/1999/xhtml" style="width:100%;height:100%;${font};font-size:14px">`;
  links.forEach((link, idx) => {
    const seperateSymbol = idx < links.length - 1 ? caret : '';
    res += `<span style="padding:0 10px;vertical-align:middle;${
      idx < links.length - 1 ? '' : 'color:#CCCCCC'
    }">${link}</span>${seperateSymbol}`;
  });
  res += '</div></foreignObject></svg>';
  return { svg: res, width, height: 16 };
};
export const convertRatingToSvg = (data) => {
  const value = data.split('/');
  const validateValue = (value) =>
    parseInt(value) > 10 ? 10 : parseInt(value) < 0 || isNaN(parseInt(value)) ? 0 : parseInt(value);
  const star = validateValue(value[0]);
  const maxStar = validateValue(value[1]);
  const rest = (maxStar < 3 ? 3 : maxStar) - star;
  const width = 24 * (star + rest);
  let res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${width}px" height="24px">` +
    '<foreignObject width="100%" height="100%">';
  for (let i = 0; i < star; i++) {
    res += `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
			 <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/>
			 </svg>`;
  }
  for (let i = 0; i < rest; i++) {
    res += `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd">
			 <path d="M15.668 8.626l8.332 1.159-6.065 5.874 1.48 8.341-7.416-3.997-7.416 3.997 1.481-8.341-6.064-5.874 8.331-1.159 3.668-7.626 3.669 7.626zm-6.67.925l-6.818.948 4.963 4.807-1.212 6.825 6.068-3.271 6.069 3.271-1.212-6.826 4.964-4.806-6.819-.948-3.002-6.241-3.001 6.241z"/>
			 </svg>`;
  }
  res += '</foreignObject></svg>';
  return { svg: res, width: width, height: 24 };
};
export const convertCalendarToSvg = (data) => {
  const check = isValidDate(new Date(data));
  const date = !check ? new Date() : new Date(data);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  date.setDate(1);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  const prevLastDay = new Date(date.getFullYear(), date.getMonth(), 0).getDate();
  const firstDayIndex = date.getDay();
  const lastDayIndex = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDay();
  const nextDays = 7 - lastDayIndex - 1;

  const drawCalendar = (month, year) => {
    const calendar = document.createElement('div');
    calendar.style = `background: #fff;`;
    const headCalendar = createHeaderCalendar(month, year);
    calendar.appendChild(headCalendar);
    const bodyCalendar = createBodyCalendar(month, year);
    calendar.appendChild(bodyCalendar);
    return calendar.outerHTML;
  };
  const createHeaderCalendar = (month, year) => {
    const header = document.createElement('div');
    const headingTop = document.createElement('div');
    headingTop.style = `display: flex; justify-content: start; font-size: 18px;font-weight: bold;background-color: #fff;padding-bottom: 4px;padding-bottom: 2px; border-bottom: 1px solid; margin-bottom: 2px;`;
    const yearIndex = document.createElement('span');
    yearIndex.innerText = `${LABEL_MONTH[month]} ${year}`;
    headingTop.appendChild(yearIndex);
    header.appendChild(headingTop);
    const titleDays = document.createElement('div');
    titleDays.style = `display: flex;`;
    for (let head = 0; head < LABEL_DATE.length; head++) {
      const thead = document.createElement('div');
      thead.style = `flex: 1;text-align: center;background-color: #fff;`;
      thead.innerHTML = LABEL_DATE[head];
      titleDays.appendChild(thead);
    }
    header.appendChild(titleDays);
    return header;
  };
  const createBodyCalendar = () => {
    const body = document.createElement('div');
    body.style = `width: 100%; display: flex;flex-wrap: wrap`;
    const wrapper = document.createElement('div');

    let days = '';
    for (let x = firstDayIndex; x > 0; x--) {
      days += `<div class="prev-date" style="width: 37.14px;text-align: center;background-color: #fff;color: #aaa;">${prevLastDay -
        x +
        1}</div>`;
    }
    for (let i = 1; i <= lastDay; i++) {
      if (i === day) {
        days += `<div class="today" style="width: 37.14px;text-align: center;background-color: #000;color: #fff; border-radius: 4px;">${i}</div>`;
      } else {
        days += `<div style="width: 37.14px;text-align: center;background-color: #fff;">${i}</div>`;
      }
    }
    for (let j = 1; j <= nextDays; j++) {
      days += `<div class="next-date" style="width: 37.14px;text-align: center;background-color: #fff;color: #aaa;">${j}</div>`;
    }
    wrapper.innerHTML = `<div style="width: 100%;display: flex;flex-wrap: wrap;">${days}</div>`;
    body.appendChild(wrapper);
    return body;
  };
  const heigth = lastDay + nextDays >= 36 ? 153 : 135;
  let res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="260px" height="${heigth}px">` +
    '<foreignObject width="100%" height="100%">' +
    '<div xmlns="http://www.w3.org/1999/xhtml">';
  res += drawCalendar(month, year) + '</div></foreignObject></svg>';
  return { svg: res, width: 260, height: heigth };
};

export const convertMenuBarToSvg = (data) => {
  const items = data.split(',');

  const modifiedItems = items.map((item) => (item.startsWith('*') ? item.slice(1) : item));

  const { textWidth } = getTextSize(modifiedItems.join(''), {
    fontSize: 15,
  });

  const PADDING = 20;
  const EPS = items.length * 5;
  const totalWidth = textWidth + items.length * PADDING + EPS;

  const font = "font-family:'Helvetica',sans-serif";
  let res =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${totalWidth}px" height="30px">` +
    '<foreignObject width="100%" height="100%">' +
    `<div xmlns="http://www.w3.org/1999/xhtml" style="width:100%;height:100%;${font};font-size:14px;"><div style="border: 1px solid #000;width: calc(100% - 2px); height: calc(100% - 2px); display: flex; align-items: center;">`;

  items.forEach((item, index) => {
    const bgColor = item[0] === '*' ? 'background-color:#CCCCCC' : '';
    const border = index === items.length - 1 ? '' : 'border-right: 1px solid #000';
    res += `<div style="padding: 0 ${PADDING /
      2}px;${bgColor};width: 100%;height: 100%;align-items: center;display: flex;justify-content: center;${border};white-space: nowrap;">${
      item[0] === '*' ? item.substr(1) : item
    }</div>`;
  });

  res += '</div></div></foreignObject></svg>';
  return { svg: res, width: totalWidth, height: 30 };
};
